// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__xgO2t","actionsCol":"EnrolledClinics_actionsCol__2LF-7"};